import {Component, OnInit, ViewChild} from '@angular/core';
import {Job} from '../domain/job';
import {JobsService} from '../services/jobs.service';
import {Router} from '@angular/router';
import moment from 'moment-timezone';
import {
  CSS_FAILED,
  CSS_OK,
  CSS_WARNING,
  SharedDataService,
  STATUS_COMPLETE,
  STATUS_FAILED,
  STATUS_FORECAST,
  STATUS_MESSAGE_WAITING,
  STATUS_RUNNING
} from '../services/shared-data.service';
import {MessageService} from 'primeng/api';
import {DatePipe} from '@angular/common';
import {UIChart} from 'primeng/chart';
import {AuthenticationGuard} from '../oauth/authentication.guard';

@Component({
    selector: 'app-execution-details',
    templateUrl: './execution-details.component.html',
    styleUrls: ['./execution-details.component.css'],
    standalone: false
})
export class ExecutionDetailsComponent implements OnInit {
  ExecutionCard= false;
  application: string;
  location:string;
  jobName: string;
  description:string;

  jobForecast: Job[];
  jobPrevious: Job[];

  resource: string;
  detail: Job;
  jobGroup: any;
  detailsList: any;

  // Data For Graph
  dates : any[];
  runTimes:any[];
  averages:any[];
  data:any;
  chartOptions:any;

  cardOpen: boolean;
  cardOpenForecast: boolean;

  // tables
  tPrevious= true;
  tForecast= true;

  cardIcon: String;
  cardIconForecast: String;
  progressSpinner = false;
  graphOpen: false;
  graphType: string = "line";
  otherGraph: string = "Bar";
  isLine: boolean=true;

  @ViewChild("chart", { static: false }) chart: UIChart;


  constructor(private jobsService: JobsService, private route: Router,
               private sharedDataService: SharedDataService,
              private authorizationService: AuthenticationGuard, private datePipe: DatePipe,
              private messageService: MessageService
              ) {

  }
  ngOnInit() {


    // Retrieving jobID being checked.
    // In  case the page is refreshed or user goes directly to that site, it is redirected to main page.
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.cardIcon = 'fa fa-plus';
    this.cardIconForecast = 'fa fa-plus';
    if (this.sharedDataService.getJob().application !=null){
      // From Dashboard
      this.jobName = this.sharedDataService.getJob().jobName;
      this.resource = this.sharedDataService.getResource();
    }  else {
      // From executions
      this.jobName = this.sharedDataService.getJob().toString();
      this.resource = this.sharedDataService.getResource();
    }
    setTimeout(()=>{
      this.getJobDetails();
    });


  }

  getJobDetails(): void {
    this.detailsList = [];
    setTimeout(() => {

          //JobDetails
        this.jobsService.getJob(this.resource, this.jobName)
          .subscribe(jobs => {
            this.jobGroup = jobs;
            // for Job details main content
            this.detail= this.jobGroup[0];
            this.application = this.jobGroup[0].application;
            this.location = this.jobGroup[0].location;
            this.description = this.jobGroup[0].description;
            this.getLists(this.jobGroup);
            this.setGraph(this.jobGroup);
            this.detailsList.push([this.detail.application,this.detail.location,this.detail.jobName,this.detail.description,this.detail.commands]);
            this.progressSpinner =true;
            this.ExecutionCard=true;
          });

    });
  }

  statusHandler(status:string): string{
    if (status.indexOf(STATUS_COMPLETE) >= 0 || status.indexOf(STATUS_FORECAST) >= 0)
      return CSS_OK;
    else if (status.indexOf(STATUS_FAILED) >= 0 || status.indexOf(STATUS_MESSAGE_WAITING) >= 0)
      return CSS_FAILED;
    else if (status.indexOf(STATUS_RUNNING) >= 0)
      return CSS_WARNING;
  }

  statusIconHandler(status:string): string{
    if (status.indexOf(STATUS_COMPLETE) >= 0)
      return "fa fa-check";
    else if (status.indexOf(STATUS_FAILED) >= 0)
      return "fa fa-close";
    else if (status.indexOf(STATUS_RUNNING) >= 0)
      return "fa fa-spinner";
    else if (status.indexOf(STATUS_FORECAST) >= 0)
      return "fa fa-calendar";
    else
      return "fa fa-warning";
  }

  showmore() {
    if(this.cardOpen) {
      this.cardOpen = false;
      this.cardIcon = 'fa fa-plus';
      this.tPrevious = true;

    }
    else{
      this.cardOpen = true;
      this.cardIcon = 'fa fa-minus';
      this.tPrevious = false;

      this.cardOpenForecast = false;
      this.cardIconForecast = 'fa fa-plus';
      this.tForecast = true;
    }
  }
  showmoreForecast() {
    if(this.cardOpenForecast) {
      this.cardOpenForecast = false;
      this.cardIconForecast = 'fa fa-plus';
      this.tForecast = true;

    }
    else{
      this.cardOpenForecast = true;
      this.cardIconForecast = 'fa fa-minus';
      this.tForecast = false;

      this.cardOpen = false;
      this.cardIcon = 'fa fa-plus';
      this.tPrevious = true;
    }
  }


  private getLists(jobGroup: any) {
    this.jobForecast = [];
    this.jobPrevious = [];
    jobGroup.forEach(job =>{
      if (job.status === STATUS_FORECAST){
        this.jobForecast.push(job);
      }else{
        this.jobPrevious.push(job);
      }
    });
  }

  //   Graph
  selectData(event) {
    this.messageService.add({ key: 'tl', severity: 'info', summary: this.data.labels[event.element._index], detail: this.data.datasets[event.element._datasetIndex].data[event.element._index]});
  }

  private setGraph(jobGroup : any) {
    this.dates =[];
    this.averages=[];
    this.runTimes=[];

    jobGroup.forEach(job =>{
      if(job.jobInstance != 'SCHEDULED'){
        let d = new Date(job.startTimestampUtc);
        this.dates.push(this.datePipe.transform(d,'dd/MM/yy'));
        this.averages.push(job.averageTime);
        this.runTimes.push(job.runTime);
      }
    });

    this.chartOptions= {
      scales: {

        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'minutes'
          },
          ticks: { min: 0, }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Dates of Execution'
          }
        }]
      }
    }
    this.data = {
      labels: this.dates,
      axisY:{
       label: "minutes",
      },
      datasets: [
        {
          label: 'Job Run Time',
          // fill: '#4bc0c0',
          fill: false,
          backgroundColor: '#EC8F25',
          borderColor: '#EC8F25',
          data: this.runTimes,
        },
        {
          label: 'Average Execution Time',
          // fill: '#2399e5',
          fill: false,
          backgroundColor: '#3C6C8D',
          borderColor: '#3C6C8D',
          data: this.averages
        }
      ]
    }
  }


  changeGtype() {
    this.isLine = !this.isLine;
    if(this.isLine == true){
      this.graphType = "line";
      this.otherGraph="Bar";

    } else {
      this.graphType= "bar";
      this.otherGraph="Line";

    }
    setTimeout(()=>{
      this.chart.reinit();
    })
  }
}
